import { Component, type ErrorInfo, type ReactNode } from 'react';

type State = { error: Error | null };

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('URBANIK_RENDER_ERROR', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="app-fatal-error" role="alert">
        <section>
          <span>URBANIK · ERROR DE INTERFAZ</span>
          <h1>No pudimos mostrar esta pantalla</h1>
          <p>La sesión y los datos permanecen intactos.</p>
          <pre>{this.state.error.message || 'Error desconocido de renderizado.'}</pre>
          <button
            type="button"
            onClick={() => {
              window.location.hash = '#login';
              window.location.reload();
            }}
          >
            Volver al acceso
          </button>
        </section>
      </main>
    );
  }
}
